import React from 'react'
import { Link } from 'react-router-dom'
import { ToolkitPageLayout } from '../../../components'

interface Breadcrumb {
  label: string
  path: string
}

export const EffectivenessOfInfusionClinicPage: React.FC = () => {
  const pageTitle = 'Effectiveness of Infusion Clinic'
  const breadcrumbs: Breadcrumb[] = [
    { label: 'Toolkit', path: '/toolkit' },
    { label: 'Community', path: '/toolkit/community' },
    {
      label: 'Community-Based Resources',
      path: '/toolkit/community/community-based-resources'
    },
    {
      label: pageTitle,
      path: '/toolkit/community/effectiveness-of-infusion-clinic'
    }
  ]

  return (
    <ToolkitPageLayout title={pageTitle} breadcrumbs={breadcrumbs}>
      <div className="prose max-w-none text-[#3C2416]">
        {/* Video Section */}
        <div className="mb-8">
          <figure className="max-w-3xl mx-auto">
            {/* TODO: Host video and update src. Add appropriate Tailwind classes for responsive video. */}
            <div className="aspect-w-16 aspect-h-9 rounded-lg overflow-hidden shadow-lg">
              <iframe
                src="https://www.dropbox.com/scl/fi/qe8ib3mrxoci7ffma14at/JH-Carroll-David-Pain-in-SCD-1.mp4?rlkey=of75ufs3vr7zjzb6m5gjc0jlg&dl=0&dl=1"
                title="Patient satisfaction in acute settings; Creating an Institution Wide Approach to Pain Management Strategies"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full h-full"
              ></iframe>
            </div>
            <figcaption className="mt-2 text-sm text-center text-gray-600">
              Patient satisfaction in acute settings;{' '}
              <em>
                Creating an Institution Wide Approach to Pain Management
                Strategies
              </em>
            </figcaption>
          </figure>
        </div>

        {/* Placeholder for additional content if any */}
        {/* <p>
          Additional textual content or other elements related to the effectiveness of infusion clinics can be placed here.
        </p> */}
      </div>

      {/* All Done Button */}
      <div className="mt-12 mb-8 text-center">
        <Link
          to="/toolkit/community/community-based-resources" // Link back to the parent page
          className="bg-[#A6410A] hover:bg-[#894d35] text-white rounded-md px-6 py-3 text-lg font-medium transition-colors duration-200 shadow-md hover:shadow-lg"
        >
          All done? Click here to return to Community-Based Resources
        </Link>
      </div>
    </ToolkitPageLayout>
  )
}
